/* import { createApp } from 'vue';
import App from './App.vue';
import "bootstrap/dist/css/bootstrap.min.css";

import "bootstrap";
import router from './router';
import store from './store';
import authModule from './modules/authModule.js';
import dateFormat from './modules/dateFormat.js';

import HelpPopup from './components/HelpPopup.vue';

createApp(App)
  .use(router)
  .use(store)
  .use(authModule)
  .use(dateFormat)
  .component('HelpPopup', HelpPopup)
  .mount('#app'); */
  import { createApp } from 'vue';
  import { createPinia } from 'pinia';
  import App from './App.vue';
  import "bootstrap/dist/css/bootstrap.min.css";
  import "bootstrap";
  import router from './router';
  import store from './store';
  import authModule from './modules/authModule.js';
  import dateFormat from './modules/dateFormat.js';
  
  import Modal from './components/Modal.vue';
  //import HelpPopup from './components/HelpPopup.vue';
  
  const app = createApp(App);
  
  // Configura propiedades globales
  app.config.globalProperties.$auth = authModule;
  app.config.globalProperties.$dateFormat = dateFormat;
  
  // Usa los plugins y componentes necesarios
  app.use(createPinia());
  app.use(router)
     .use(store)
     .component('Modal', Modal);
  
  // Monta la aplicación en el elemento con id 'app'
  app.mount('#app');
